export const ARRIVAL_REPORT_ENDPOINT = `report/arrival`;
